import { TBusinessFormData } from 'src/@types';
import { IBusinessSFilter } from 'src/@types/SearchFilterTypes';
import { IBusiness } from 'src/models';
import { IPipeline } from 'src/models/management/category/Pipeline';
import { TApiResponseData } from 'src/service/apiTypes';
import instance from 'src/service/axios';
import { HEADERS_MULTIPART } from 'src/static/constants';
import objectToQueryString from 'src/utils/objectToQueryString';

const SUB_URL = '/v1/business';

const convertDataInfoToFormData = (data: TBusinessFormData) => {
  const formData = new FormData();

  // 기본 필드 추가
  Object.entries(data).forEach(([key, value]) => {
    if (value === undefined || value === null) return;

    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        if (item instanceof File) {
          formData.append(`${key}`, item);
        } else if (typeof item === 'string') {
          formData.append(`${key}`, item);
        } else {
          // businessSubList 처리
          Object.entries(item).forEach(([subKey, subValue]) => {
            if (subValue !== undefined && subValue !== null) {
              if (Array.isArray(subValue)) {
                // File 배열 처리
                subValue.forEach((file) => {
                  if (file instanceof File) {
                    formData.append(`${key}[${index}].${subKey}`, file);
                  } else {
                    formData.append(`${key}[${index}].${subKey}`, String(file));
                  }
                });
              } else if (subValue instanceof File) {
                formData.append(`${key}[${index}].${subKey}`, subValue);
              } else {
                formData.append(`${key}[${index}].${subKey}`, String(subValue));
              }
            }
          });
        }
      });
    } else if (value instanceof File) {
      formData.append(key, value);
    } else {
      formData.append(key, String(value));
    }
  });

  return formData;
};

/**
 * 사업 목록 조회
 */
export const getBusiness = async (searchFilter?: IBusinessSFilter) => {
  try {
    const url = SUB_URL + objectToQueryString(searchFilter || {});
    const response = await instance.get<TApiResponseData<IBusiness[]>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
        pagination: response.data.pagination,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 사업 상세 조회
 */
export const getDetail = async (businessSid?: number) => {
  try {
    const url = `${SUB_URL}/${businessSid}`;
    const response = await instance.get<TApiResponseData<IBusiness>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
    return {
      success: true,
      data: response,
    };
  } catch (error) {
    console.error(error);
  }
};
/**
 * 비즈니스 등록 시 사용할 카테고리별 파이프라인 조회
 */
export const getCategoryPipeline = async (categorySid?: number) => {
  try {
    const url = `/v1/category/${categorySid}/pipeline`;
    const response = await instance.get<TApiResponseData<IPipeline[]>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
    return {
      success: true,
      data: response,
    };
  } catch (error) {
    console.error(error);
  }
};

/**
 * 등록
 */
export const post = async (data: TBusinessFormData) => {
  try {
    const formData = convertDataInfoToFormData(data);

    const response = await instance.post<TApiResponseData<IBusiness>>(
      `${SUB_URL}`,
      formData,
      HEADERS_MULTIPART,
    );

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 순서 변경을 위한 목록 조회(카테고리의 해당하는 비즈니스 목록만 조회되는 api)
 */
export const getBusinessOrderList = async (landCd: string) => {
  try {
    const url = `${SUB_URL}/list?langCd=${landCd}`;
    const response = await instance.get<TApiResponseData<IBusiness[]>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 수정
 */
export const put = async (businessSid: number, data: TBusinessFormData) => {
  try {
    const formData = convertDataInfoToFormData(data);

    const response = await instance.put<TApiResponseData<IBusiness>>(
      `${SUB_URL}/${businessSid}`,
      formData,
      HEADERS_MULTIPART,
    );

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 사업 삭제
 */
export const remove = async (businessSid?: number) => {
  try {
    const url = `${SUB_URL}/${businessSid}`;
    const response = await instance.delete<TApiResponseData<IBusiness>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};
